<template>
  <v-container>
    <v-row dense>
      <v-col>
        <v-card>
          <!-- <v-progress-linear color="red" height="20" striped indeterminate>
          </v-progress-linear> -->
          <v-card-title
            style="background-color: #b71c1c"
            class="headline d-flex justify-center"
          >
            <!-- <v-icon x-large color="white">
              mdi-alert-octagon-outline
            </v-icon> -->
            <div style="color: white" class="text-decoration-underline">
              <h2>ปิดปรับปรุง</h2>
            </div>
            <!-- <v-icon x-large color="white">
              mdi-alert-octagon-outline
            </v-icon> -->
          </v-card-title>
          <v-divider></v-divider>
          <v-card class="d-flex justify-center mb-6" elevation="0">
            <v-card elevation="0" class="d-flex justify-center ma-6">
              <h1>{{ this.$route.query.start }}</h1>
            </v-card>
            <v-card elevation="0" class="d-flex justify-center ma-6">
              <h1>-</h1>
            </v-card>
            <v-card elevation="0" class="d-flex justify-center ma-6">
              <h1>{{ this.$route.query.end }}</h1>
            </v-card>
          </v-card>
          <v-divider></v-divider>
          <v-progress-linear color="red" height="20" striped indeterminate>
          </v-progress-linear>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Maintenace",
  data() {
    return {
      items: [
        {
          color: "#1F7087",
          src: "https://cdn.vuetifyjs.com/images/cards/foster.jpg",
          title: "Supermodel",
          artist: "Foster the People",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-family: "Montserrat", sans-serif;
  font-size: 150px;
  font-weight: 900;
}
</style>
